import { useState } from "react";
import { useDebouncedValue } from "@mantine/hooks";
import { UserRoleEnum } from "@therapprove/common";

export type TeamFilters = {
    roleNames: UserRoleEnum[];
    isActive: boolean | undefined;
    locationIds: string[];
};

const defaultFilters: TeamFilters = {
    roleNames: [],
    isActive: undefined,
    locationIds: []
};

export const useTeam = () => {
    // State
    const [search, setSearch] = useState("");
    const [debouncedSearch] = useDebouncedValue(search, 300);
    const [filters, setFilters] = useState<TeamFilters>(defaultFilters);

    return {
        search,
        setSearch,
        debouncedSearch,
        filters,
        setFilters
    };
};
